import {
  index as baseIndex,
  request,
 } from './Base';

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all error lines
 */
export function fetchErrorLines(distinct) {
  let search = {}
  if(distinct === true) {
    search.distinct = true;
  }
  return baseIndex('transatel_api_file_error_lines', 1, 0, search);
}

/******************************************************************************
 * OTHER FUNCTION                                                             *
 ******************************************************************************/

/**
 * start to process error line
 */
export function processErrorLines() {
  return request('/transatel_file_process_error_lines');
}
